var results = [];
var freshPage = 0;
function getQueryParam(url, param) {
  const urlObj = new URL(url);
  return urlObj.searchParams.get(param);
}
(function (XHR) {
  "use strict";
  let open = XHR.prototype.open;
  let send = XHR.prototype.send;

  XHR.prototype.open = function (method, url, async, user, pass) {
    this._url = url;
    open.call(this, method, url, async, user, pass);
  };

  XHR.prototype.send = function (data) {
    let self = this;
    let url = this._url;
    if (
      url &&
      url.toLowerCase() ===
        "https://7isd4webla3xcfiy7j79t5vs-fast.searchtap.net/v2"
    ) {
      const body = JSON.parse(data);
      if (location.href.includes("p=") && freshPage == 0) {
        const page = getQueryParam(location.href, "p");
        if (page){
          body.count =
            parseInt(page) *
            window.sq.config.themeSettings.countOfProductsShown;
          body.skip = 0;
        }          
      }
      if (body.skip == 0) results = [];

      freshPage++;
      data = JSON.stringify(body);
    }
    send.call(this, data);
  };
})(XMLHttpRequest);

window.addEventListener("DOMContentLoaded", () => {
  const updateSortLabel = () => {
    if (window.innerWidth <= 767) {
      const sortLabel = document.querySelector(".sq-sort-label");
      if (sortLabel) {
        sortLabel.innerText = "Sort";
      }
    }
  };
});

document.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelector(".swiperSq")) return;
  const swiper = new Swiper(".swiperSq", {
    // Optional parameters
    loop: true,

    // If we need pagination
    pagination: {
      el: ".swiper-pagination",
    },
    spaceBetween: 30,
    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    // And if we need scrollbar
    scrollbar: {
      el: ".swiper-scrollbar",
    },
    breakpoints: {
      300: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
      350: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 4.5,
        spaceBetween: 30,
      },
    },
    on: {
      slideChange: function () {
        if (this.activeIndex === 0) {
          document.querySelector(
            ".swiperSq .swiper-button-prev"
          ).style.display = "none";
        } else {
          document.querySelector(
            ".swiperSq .swiper-button-prev"
          ).style.display = null;
        }
      },
      reachBeginning: function () {
        console.log("First slide is visible");
        // Add your custom event logic here
      },
    },
  });
  const collectionCaraousel = document.querySelector(
    ".sq-collection-caraousel"
  );
  let sqWiper = document.querySelector(".swiperSq .swiper-wrapper");
  if (sqWiper) {
    let children = sqWiper.children;
    if (children.length < 4) {
      sqWiper.classList.add("center");
    }
    document.querySelectorAll(".swiperSq .sq-hidden").forEach((e) => {
      e.classList.remove("sq-hidden");
    });
  }
  if (collectionCaraousel) collectionCaraousel.classList.add("loaded");
  if (collectionCaraousel && !collectionCaraousel.querySelector("div"))
    collectionCaraousel.style.display = "none";
});

setTimeout(() => {
  document.querySelector('[name="q"]').addEventListener("focus", (e) => {
    let searchInput = document.querySelector('[name="q"]');
    let rect = searchInput.getClientRects()[0];
    let dropdown = document.querySelectorAll(
      ".search-product-card .sq-dropdown-body"
    );
    if (dropdown.length) {
      dropdown.forEach((el) => {
        el.closest(".search-product-card").classList.add("fixPosition");
        el.style.left = "unset !important";
        el.style.right = window.innerWidth - rect.right + "px";
      });

      // dropdown.style.top = (rect.top + rect.height) + "px";
    }
  });
}, 1000);

// Hide Tag on Same Collection
window.sq.removeTagFromCollection = function (tagUrl) {
  const url = window.location.href;
  const parts = url.split("/");
  const targetText = parts[parts.length - 1];
  if (targetText.includes(tagUrl)) {
    return false;
  }
  return true;
};
window.sq.hideFilters = function (store) {
  // update Total count on load more button
  setTimeout(() => {
    let sqTotal = document.querySelector(".sq-total");
    let sparqCard = document.querySelectorAll(".sparq-card.js-product-card");
    if (sqTotal)
      sqTotal.innerHTML = `${sparqCard.length} of ${store.totalHits} products`;
  }, 200);
  if (!window.location.href.includes("/bestseller")) return true;
  setTimeout(() => {
    let SqFilterGroup = document.querySelector(
      ".sq-filter-group-tags_collection__pf2da8wrmxjbzdvib94328qk"
    );
    if (SqFilterGroup) {
      let filter = SqFilterGroup.querySelector(".sq-filter-value.bestsellers");
      filter.parentNode.style.display = "none";
    }

    if (window.location.href.includes("/bestseller-bras"))
      hideFiltersForBestSellerBra();
  }, 500);
  return true;
};

function hideFiltersForBestSellerBra() {
  let filterGroup = document.querySelector(
    ".sq-filter-group-tags_collection__pf2da8wrmxjbzdvib94328qk"
  );
  if (filterGroup) {
    filterGroup.classList.add("bestseller-bras");
  }
}

document.addEventListener("click", (e) => {
  let sqfilter = e.target;
  if (
    sqfilter.getAttribute("class") &&
    sqfilter.getAttribute("class").includes("sq-filter-title-")
  ) {
    let sqFilterDropdown = sqfilter.closest(".sq-filter-dropdown");
    if (sqFilterDropdown) {
      if (
        sqFilterDropdown.classList.contains("close") ||
        !sqFilterDropdown.classList.contains("open")
      ) {
        sqFilterDropdown.classList.remove("close");
        sqFilterDropdown.classList.add("open");
      } else {
        sqFilterDropdown.classList.add("close");
        sqFilterDropdown.classList.remove("open");
      }
    }
  }
  if (!sqfilter.closest(".sq-filter-dropdown")) {
    document.querySelectorAll(".sq-filter-dropdown").forEach((e) => {
      e.classList.remove("open");
    });
  }
  replaceEverYou(e);
});

window.sq.mastectomyBras = function () {
  if (!window.location.href.includes("/collections/mastectomy-bras"))
    return true;
  setTimeout(() => {
    if (window.location.href.includes("/collections/essentials")) {
      let showMore = document.querySelector(".sq-show-more");
      let topbar = document.querySelector(".sq-topbar");
      if (topbar) topbar.style.display = "none";
      if (showMore) showMore.style.display = "none";
    }
    document
      .querySelectorAll(
        ".sq-filter-group-tags_wig_type_4h77i5ovuirtkbh1efsjqg31"
      )
      .forEach((e) => {
        e.classList.add("hide-mastectomy-bras");
        let compressionFilter = e.querySelector(".sq-filter-value.compression");
        let drainSupportFilter = e.querySelector(
          ".sq-filter-value.drain_support"
        );
        compressionFilter.parentNode.style.display = "none";
        drainSupportFilter.parentNode.style.display = "none";
      });
  }, 500);
  return true;
};

window.sq.customizedMastectomyBras = function (store) {
  hideTypeOnPostSurgical();
  hideMoreFilterBtn(store);
  if (!window.location.href.includes("collections/customized-mastectomy-bras"))
    return true;
  setTimeout(() => {
    document
      .querySelectorAll(
        ".sq-filter-group-tags_wig_type_4h77i5ovuirtkbh1efsjqg31"
      )
      .forEach((e) => {
        e.classList.add("hide-customized");
        let customizedFilter = e.querySelector(".sq-filter-value.customized");
        customizedFilter.parentNode.style.display = "none";
      });
  }, 100);
  return true;
};

// Hide More Filter Button if Filter is  < 2
function hideMoreFilterBtn(store) {
  setTimeout(() => {
    let filters = store?.filters.filter(
      (f) =>
        (f.items && f.items.length && f.isVisible) || f.stFieldName == "price"
    );
    let showMore = document.querySelector(".sq-show-more");
    let sqApp = document.querySelector(".sq-app-collection");
    if (filters.length > 2 && showMore) {
      showMore.style.display = "block";
    } else {
      if (sqApp) sqApp.classList.add("hide-show-more");
      if (showMore) showMore.style.display = "none";
    }
  }, 200);
}

function hideTypeOnPostSurgical() {
  let sqApp = document.querySelector(".sq-app-collection");
  if (window.location.href.includes("collections/post-surgical") && sqApp) {
    sqApp.classList.add("hide-type-post-surgical");
  }
}

window.sq.getImageSrc = function (item, value) {
  let src = convertToFilename(value);
  src =
    "https://cdn.shopify.com/s/files/1/0264/5190/2554/files/large-" +
    formatString(item.vendor) +
    "-" +
    src;
  return src;
};

function formatString(input) {
  return (
    input
      .toLowerCase() // Convert to lowercase
      .replace("m.m.", "m-m")
      .replace(/[^a-z0-9\s/#-]/g, "")
      // .replace(/[*./\\]/g, "") // Remove specified signs
      .replace(/\s+/g, "-")
  ); // Replace spaces with hyphens
}

function convertToFilename(input) {
  let str = input
    .toLowerCase() // Convert to lowercase
    .normalize("NFD")
    .replace(/[\u0301]/g, "")
    .replace(/[^a-z0-9\s/#-]/g, "") // Remove all non-alphanumeric characters except spaces
    .replace(/[\s/#]+/g, "-"); // Replace spaces with hyphens

  return `${str}_50x.png`;
}

window.sq.notShowFiltersOnCollections = function () {
  let href = window.location.href;
  let arrayOfCollections = [
    "/collections/headwear-accessories",
    "/collections/essentials",
    "/collections/adaptive-garments",
    "/collections/drain-support",
    "/collections/post-surgical-essentials",
  ];

  // Check if any of the collections are in the current URL
  for (let collection of arrayOfCollections) {
    if (href.includes(collection)) {
      return false; // If any collection is found in the URL, return false
    }
  }

  return true; // If none of the collections are found in the URL, return true
};

// Switch Tab in Search Page
function toggleSqTab(tabClass) {
  let sqWrapper = document.querySelector(".sq-app-wrapper");
  if (sqWrapper) {
    if (tabClass === "sq-product-tab") {
      sqWrapper.classList.add("sq-product-tab");
      sqWrapper.classList.remove("sq-article-tab");
    } else {
      sqWrapper.classList.remove("sq-product-tab");
      sqWrapper.classList.add("sq-article-tab");
    }
  }
}

window.sq.checkSwatch = async function (item) {
  return true;
  try {
    const productHandle = item.handle;
    const response = await fetch(`/products/${productHandle}.json`);

    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }

    const productData = await response.json();
    // setTimeout(() => {
    const sparqCard = document.querySelector(
      `[product-handle="${item.handle}"]`
    );
    const swatches = sparqCard
      ? sparqCard.querySelector(".sq-pallate-wrapper")
      : null;
    if (
      productData.product.options &&
      productData.product.options[0].name !== "Color"
    ) {
      if (swatches) swatches.style.display = "none";
    }
    if (swatches) swatches.classList.add("loaded");
    // });
    // Do something with the productData
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

window.sq.fetchImage = async function (item) {
  try {
    let response = await fetch(
      `${window.location.origin}/pages/${item.handle}?view=sparq`
    );
    if (response.ok) {
      let data = await response.json();
      setTimeout(() => {
        let sparqCard = document.querySelector(
          `.sparq-card[page-handle="${item.handle}"]`
        );
        let imageEle = sparqCard.querySelector("img.item-image");
        let featureImg = data.feature_image.replace("//", "");
        imageEle.src = "https://" + featureImg;
        if (data.external_link) {
          // for external link in article tab
          sparqCard.querySelectorAll("a").forEach((e) => {
            e.setAttribute("target", "__blank");
          });
        }
      }, 200);
      return true; // Return the fetched data
    } else {
      console.error("HTTP-Error: " + response.status);
      return null; // Return null or handle the error as needed
    }
  } catch (error) {
    console.error("Fetch error: " + error.message);
    return null; // Return null or handle the error as needed
  }
  return true;
};

let lastScrollTop = 0;
window.addEventListener(
  "scroll",
  function () {
    let currentScrollTop =
      window.pageYOffset || document.documentElement.scrollTop;
    let header = document.querySelector("header");
    let queryInput = document.querySelector('[name="q"]');
    if (window.innerWidth > 767) {
      queryInput = document.querySelector('[name="q"]');
    } else {
      queryInput = document.querySelectorAll('[name="q"]')[1];
    }
    let strip = document.querySelector(
      ".shopify-section.shopify-section-group-header-group-with-cart-drawer"
    );
    let dropdown = document.querySelector(".sq-dropdown.search-product-card");
    let headerElement = document.querySelector(
      ".shopify-section.shopify-section-group-header-group-with-cart-drawer.header-section"
    );
    // User scrolled up
    if (headerElement && !headerElement.classList.contains("is-collapsed")) {
      if (dropdown) {
        dropdown.classList.remove("hide-dropdown");
      }
    }
    if (headerElement && headerElement.classList.contains("is-collapsed")) {
      if (dropdown) {
        dropdown.classList.add("hide-dropdown");
      }
    }
    if (dropdown) {
      if (document.body.getClientRects()[0].top == 0) {
        dropdown.querySelector(".sq-dropdown-body").style.top =
          queryInput.getClientRects()[0].height +
          queryInput.getClientRects()[0].top +
          "px";
      } else {
        dropdown.querySelector(".sq-dropdown-body").style.top =
          queryInput.getClientRects()[0].height +
          queryInput.getClientRects()[0].top +
          "px";
      }
    }
    fixTopBarOnScroll();
    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // For Mobile or negative scrolling
  },
  false
);

function fixTopBarOnScroll() {
  const header = document.querySelector(".header-section");
  if (window.pageYOffset > 50) {
    header.classList.add("fixed");
  } else {
    header.classList.remove("fixed");
  }
}
function replaceEverYou(e) {
  setTimeout(() => {
    if (
      e.target.classList.contains("sq-accordion-header") ||
      (e.target.getAttribute("class") &&
        e.target.getAttribute("class").includes("sq-filter-title-"))
    ) {
      const accordion = e.target.closest(".sq-accordion")
        ? e.target.closest(".sq-accordion")
        : e.target.closest(".sq-filter-dropdown");
      accordion.querySelectorAll(".sq-filter-value").forEach((j) => {
        if (j && j.childNodes[1]) {
          if (j.innerText.includes("Everyou")) {
            if (j.innerText.includes("EverYou™")) {
            } else
              j.childNodes[1].textContent = j.innerText.replace(
                "Everyou",
                "EverYou™"
              );
          }
          if (j.innerText.includes("Gabor")) {
            if (j.innerText.includes("Gabor®")) {
            } else
              j.childNodes[1].textContent = j.innerText.replace(
                "Gabor",
                "Gabor®"
              );
          }
          if (j.innerText.includes("Henry Margu")) {
            if (j.innerText.includes("Henry Margu®")) {
              // Optionally handle the case where "Henry Margu®" is already present
            } else {
              // Replace "Henry Margu" with "Henry Margu®"
              j.childNodes[1].textContent = j.innerText.replace(
                "Henry Margu",
                "Henry Margu®"
              );
            }
          }

          if (j.innerText.includes("Hairdo")) {
            if (j.innerText.includes("Hairdo®")) {
              // Optionally handle the case where "Hairdo®" is already present
            } else {
              // Replace "Hairdo" with "Hairdo®"
              j.childNodes[1].textContent = j.innerText.replace(
                "Hairdo",
                "Hairdo®"
              );
            }
          }

          if (j.innerText.includes("Vivica A. Fox")) {
            if (j.innerText.includes("Vivica A. Fox®")) {
              // Optionally handle the case where "Vivica A. Fox®" is already present
            } else {
              // Replace "Vivica A. Fox" with "Vivica A. Fox®"
              j.childNodes[1].textContent = j.innerText.replace(
                "Vivica A. Fox",
                "Vivica A. Fox®"
              );
            }
          }

          if (j.innerText.includes("Raquel Welch")) {
            if (j.innerText.includes("Raquel Welch®")) {
              // Optionally handle the case where "Raquel Welch®" is already present
            } else {
              // Replace "Raquel Welch" with "Raquel Welch®"
              j.childNodes[1].textContent = j.innerText.replace(
                "Raquel Welch",
                "Raquel Welch®"
              );
            }
          }

          if (j.innerText.includes("Toni Brattin")) {
            if (j.innerText.includes("Toni Brattin®")) {
              // Optionally handle the case where "Toni Brattin®" is already present
            } else {
              // Replace "Toni Brattin" with "Toni Brattin®"
              j.childNodes[1].textContent = j.innerText.replace(
                "Toni Brattin",
                "Toni Brattin®"
              );
            }
          }
        }
      });
    }
  });
}
setTimeout(() => {
  const dropdown = document.querySelector(".container.sq-app.sq-dropdown");
  if (dropdown) dropdown.style.visibility = "visible";
}, 500);

// Check the page is Collection all then add css to sq filter main
window.sq.checkCollectionAll = function () {
  if (
    location.href.includes("/collections/all") ||
    location.href.includes("/search")
  )
    return "collection-all";
  return null;
};

window.sq.onData = (store) => {
  const sqTotal = document.querySelector(".sq-total");
  const sparqContainer = document.querySelector(".sparq-container");
  const sqAppWrapper = document.querySelector(".sq-app-wrapper");

  if (sqTotal && store.results.length) {
    sqTotal.style.display = null;
  }

  if (sqAppWrapper && store.results.length) {
    sqAppWrapper.style.minHeight = "max-content";
  }
  setTimeout(() => {
    let sparqRowBase = document.querySelector(".sparq-row-base");
    const mobileFilter = document.querySelector(".sparq-mobile-filter");
    if (sparqRowBase && store.results.length) {
      sparqRowBase.style.display = null;
    }
    if (mobileFilter && store.results.length) {
      mobileFilter.style.display = null;
    }
  }, 100);
  setTimeout(() => {
    // if(sparqContainer) sparqContainer.style.minHeight = "max-content";
  }, 1000);
  return store.results;
};

// Dropdown and Article Code
window.sq.getLink = function (item) {
  return `/pages/${item.handle.replaceAll("-1", "")}`;
};

window.sq.fetchImageForDropdown = async function (item) {
  try {
    let response = await fetch(
      `${window.location.origin}/pages/${item.handle}?view=sparq`
    );
    if (response.ok) {
      let data = await response.json();
      setTimeout(() => {
        let sparqCard = document.querySelector(
          `.search-result[product-handle="${item.handle}"]`
        );
        let imageEle;
        if (sparqCard) imageEle = sparqCard.querySelector("img");
        let featureImg = data.feature_image.replace("//", "");
        if (sparqCard) imageEle.src = "https://" + featureImg;
        if (data.external_link && sparqCard) {
          sparqCard.querySelectorAll("a").forEach((e) => {
            e.setAttribute("target", "__blank");
          });
        }
      }, 200);
      return true; // Return the fetched data
    } else {
      console.error("HTTP-Error: " + response.status);
      return null; // Return null or handle the error as needed
    }
  } catch (error) {
    console.error("Fetch error: " + error.message);
    return null; // Return null or handle the error as needed
  }
  return true;
};

window.sq.checkForArticleSearch = function (store) {
  const productDropdown = document.querySelector(".sq-product-dropdown");
  const articleDropdown = document.querySelector(".sq-article-dropdown");
  if (store.results.length) {
    productDropdown.style.display = "block";
    articleDropdown.style.display = "none";
    openArticlePage = false;
  } else {
    productDropdown.style.display = "none";
    articleDropdown.style.display = "block";
    articleDropdown.style.visibility = "visible";
    openArticlePage = true;
  }
  return true;
};
setTimeout(() => {
  if (location.href.includes("tab=article")) {
    // Select the first element with the class .sq-search-tab
    const searchTab = document.querySelector(".sq-search-tab");
    if (searchTab) {
      const secondChild = searchTab.children[1];
      if (secondChild) secondChild.click();
    }
  }
}, 300);
setTimeout(() => {
  document
    .querySelector('[name="q"]')
    .addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
        console.log("Item clicked");
        if (openArticlePage) {
          document.querySelector(".sq-article-dropdown .sq-view-all").click();
        } else
          document.querySelector(".sq-product-dropdown .sq-view-all").click();
      }
    });
}, 200);
window.sq.checkCollectionAll = function () {
  if (
    location.href.includes("/collections/all") ||
    location.href.includes("/search")
  )
    return "collection-all";
  return null;
};

window.sq.ondata = (store) => {
  store.results.map((item) => {
    if (!item.image.alt) item.image.alt = item.title; // set alt of image
    item.images.map((image) => {
      if (!image.alt) image.alt = item.title; // set alt of image
    });
  });
  results = [...results, ...store.results];
  return results;
};
